/**
 * 安全配置 - 修改导航组件
*/

import { Row, Col, Button } from 'antd';
import { DeleteCookies } from '../../incs/FunHelper';
import CNF from '../../incs/Config.js';
import Logo from '../../images/logo.png';

const SecurityUpdateNav = (props) => {
    return (
        <>
            <Row style={{ backgroundColor: '#001529', color: '#FFFFFF' }}>
                <Col span={3} offset={5}>
                    <a href={CNF.userUrl}>
                        <img src={Logo} style={{ height: '40px', marginTop: '5px' }} alt='' />
                    </a>
                </Col>
                <Col span={6}>
                    <h3>{props.title}</h3>
                </Col>
                <Col span={3} style={{ lineHeight: '60px' }}>
                    <span>您好，{props.username} </span>
                    <span style={{ float: 'right' }}>|</span>
                </Col>
                <Col span={1} style={{ textAlign: 'center', lineHeight: '60px' }}>
                    <Button type='link' style={{ color: '#FFFFFF' }} href={CNF.userUrl}>返回</Button>
                </Col>
                <Col span={1} style={{ textAlign: 'center', lineHeight: '60px' }}>
                    <Button type='link' style={{ color: '#FFFFFF' }} onClick={(e) => {
                        e.preventDefault();
                        DeleteCookies();
                    }}>退出</Button>
                </Col>
                <Col span={1} style={{ textAlign: 'center', lineHeight: '60px' }}>
                    <Button type='link' style={{ color: '#FFFFFF' }}>帮助</Button>
                </Col>
            </Row>
        </>
    );
}

export default SecurityUpdateNav;